import React, { useState } from 'react';

/**
 * Petite icône circulaire affichant une des 6 variantes de l'avatar SADA.
 * Fallback = fond marron avec initiale S si l'image n'est pas encore générée.
 */
const SLUGS = new Set([
  'skincare',
  'health',
  'baby',
  'histoire',
  'partenariats',
  'recrutement',
  'garde',
  'blog',
  'expertises',
]);

const AvatarIcon = ({ slug, size = 40, ring = '#5D4E37', bg = '#F5EDE4', className = '', alt = '' }) => {
  const [errored, setErrored] = useState(false);
  const valid = SLUGS.has(slug);
  const src = valid ? `/images/avatar-icons/${slug}.png` : null;
  const style = {
    width: size,
    height: size,
    background: bg,
    boxShadow: `0 0 0 2px ${ring} inset`,
  };
  return (
    <div
      className={`rounded-full overflow-hidden flex items-center justify-center flex-shrink-0 ${className}`}
      style={style}
      data-testid={`avatar-icon-${slug}`}
    >
      {src && !errored ? (
        <img
          src={src}
          alt={alt || `Icône SADA ${slug}`}
          className="w-full h-full object-cover"
          loading="lazy"
          onError={() => setErrored(true)}
        />
      ) : (
        <span
          className="font-serif font-bold"
          style={{ color: ring, fontSize: size * 0.5 }}
          aria-hidden="true"
        >
          S
        </span>
      )}
    </div>
  );
};

export default AvatarIcon;
